export default "__VITE_ASSET__9eee615a__"